import {
  DEFAULT_COST_CENTER_COLOR,
  DEFAULT_COST_CENTER_ICON,
} from '../../../../../documentostributarios/costCenters/costCenter.constants';

export const buildCostCenterCatalogMap = (catalogList = []) => {
  const map = new Map();
  catalogList.forEach((item) => {
    if (item?.id != null) map.set(String(item.id), item);
  });
  return map;
};

export const entryHasLineCostCenters = (entry) =>
  Array.isArray(entry?.entries) &&
  entry.entries.some((row) => Array.isArray(row?.costCenters) && row.costCenters.length > 0);

export const getLineCostCentersForDisplay = (row, catalogById, displayCurrency = 'CLP') => {
  const list = Array.isArray(row?.costCenters) ? row.costCenters : [];
  if (!list.length) return [];

  return list.map((cc, index) => {
    const catalogId = cc?.costCenterId != null ? String(cc.costCenterId) : '';
    const catalog = catalogById?.get?.(catalogId) ?? catalogById?.[catalogId];
    const debit = Number(cc.debit) || 0;
    const credit = Number(cc.credit) || 0;
    const side = debit > 0 ? 'debit' : 'credit';
    const amount = side === 'debit' ? debit : credit;
    const label = String(cc.label ?? catalog?.name ?? '').trim();

    return {
      key: cc.id != null ? String(cc.id) : `${catalogId}-${index}`,
      label: label || 'Centro de costo',
      side,
      amount,
      currency: cc.currency || displayCurrency,
      color: catalog?.color || DEFAULT_COST_CENTER_COLOR,
      icon: catalog?.icon || DEFAULT_COST_CENTER_ICON,
    };
  });
};

export const getEntryCostCentersForDisplay = (
  entry,
  catalogById,
  displayCurrency = 'CLP',
) => {
  const rows = Array.isArray(entry?.entries) ? entry.entries : [];
  return rows.flatMap((row) =>
    getLineCostCentersForDisplay(row, catalogById, displayCurrency),
  );
};
